/**
 * Overview Page Routes
 * legacy app: canActivate: [RoleGuard, VendorRoleGuard, ProviderViewGuard]
 *
 * Includes:
 * - /OverviewPage/* (internal)
 * - /overview-page-advocate/* (advocate view)
 * - /overview-page-advocate/health-system-details
 */

import { lazy } from 'react';
import { RouteConfig, RouteMetadata } from '../../types';

const Overview = lazy(() =>
  import('@src/apps/Overview/OverviewComponent').then(m => ({ default: m.OverviewComponent }))
);
const Hsd = lazy(() => import('@src/apps/Hsd/Hsd').then(m => ({ default: m.Hsd })));

const EXTERNAL_ACCESS_DENIED: Pick<RouteMetadata, 'externalAccess'> = {
  externalAccess: false,
};

export const overviewPageRoutes: RouteConfig[] = [
  {
    path: 'overview-page-advocate/health-system-details',
    component: Hsd,
    guards: ['auth', 'vendor', 'provider'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Health System Details',
      breadcrumb: 'Health System Details',
      preload: false,
      delay: false,
    },
  },
  {
    path: 'OverviewPage/*',
    component: Overview,
    guards: ['auth', 'role', 'vendor', 'provider'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Overview',
      breadcrumb: 'Overview',
      preload: true,
      delay: false,
      checkRoleFor: 'UHCI_Project',
    },
  },
  {
    path: 'overview-page-advocate/*',
    component: Overview,
    guards: ['auth', 'vendor', 'provider'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Overview',
      breadcrumb: 'Overview',
      preload: false,
      delay: false,
      checkRoleFor: 'UHCI_Advocate',
    },
  },
  {
    path: 'health-system-details',
    component: Hsd,
    guards: ['auth'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Health System Details',
      breadcrumb: 'Health System Details',
      preload: false,
      delay: true,
    },
  },
];

